// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3O2mI","cell":"ColumnAccessor_cell__15Gzv","firstCellAccent":"ColumnAccessor_firstCellAccent__3_K5c"};